import ELocale from '@/module/common/models/ELocale';
import getLocalStorageItem from '@/module/common/utils/localStorage/getLocalStorageItem';

export default function getLocale(locale: ELocale | null = null) {
  return locale ?? getLocalStorageItem('locale', ELocale.EN);
}
